import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { IconName, PalleteColor } from 'nanaykuna-ui-kit/loader';

@Component({
  selector: 'unicon-text-field',
  templateUrl: './text-field.component.html',
  styleUrl: '../field.component.scss',
})
export class TextFieldComponent implements OnInit, AfterViewInit {
  @Input() icon: IconName = 'bug-beetle';
  @Input() placeholder: string = '';
  @Input() value?: string;
  @Output() result: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild('textFieldElement') formField!: ElementRef<HTMLFormElement>;
  @ViewChild('formInputField') formInputField!: ElementRef<HTMLInputElement>;
  protected edit: boolean = false;
  protected hovered: boolean = false;
  protected form!: FormGroup;

  constructor(private formBuilder: FormBuilder) {
    this.setForm();
  }

  ngOnInit(): void {
    this.setInitialValue();
  }

  ngAfterViewInit(): void {
    this.setEditListeners();
  }

  private setInitialValue(): void {
    if (this.value) {
      this.form.controls['input'].setValue(this.value);
    }
  }

  private setForm(): void {
    this.form = this.formBuilder.group({
      input: new FormControl<string>(
        { disabled: true, value: '' },
        Validators.compose([Validators.required]),
      ),
    });
  }

  private setEditListeners(): void {
    const formComponent: HTMLFormElement = this.formField.nativeElement;
    formComponent?.addEventListener('mouseenter', () => {
      this.hovered = true;
    });
    formComponent?.addEventListener('mouseleave', () => {
      this.hovered = false;
    });
  }

  protected getIconColor(): PalleteColor {
    if (this.form.controls['input'].errors) {
      return 'critical-300';
    }

    if (this.edit) {
      return 'neutrals-900';
    }

    if (this.hovered) {
      return 'neutrals-900';
    }

    return 'neutrals-500';
  }

  protected onEdit(): void {
    this.edit = true;
    this.form.controls['input'].enable();
    this.formInputField.nativeElement.focus();
  }

  protected onSubmit(): void {
    this.edit = false;
    this.form.controls['input'].disable();
    this.result.emit(this.form.controls['input'].value);
  }
}
